var exports = {
  "k": "CloneAllowedToggle.module__container___MlBWRV",
  "f": "CloneAllowedToggle.module__permissionHint___MlBWRV",
};

module.exports = exports;
